import Backbone from 'backbone'
import template from './add-tree-menu.hbs'
import conductor from '../components/conductor'

const AddTreeMenu = Backbone.View.extend(/** @lends {AddTreeMenu} */{

	tagName: 'ul',

	className: 'tree-menu',

	events: {
		'click .add-page': 'onClickAddPage',
		'click .add-dialog': 'onClickAddDialog',
		'click .add-navigation-tabs': 'onClickAddNavigationTabs'
	},

	/**
	 * Tooltip attached to top-level forms that allows adding pages and
	 * navigation tabs
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Number} options.formId The id of the form to add pages or
	 * navigation tabs to
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.html(template())
		return this
	},

	onClickAddPage: function() {
		this.navigate('new-page')
	},

	onClickAddDialog: function() {
		this.navigate('new-dialog')
	},

	onClickAddNavigationTabs: function() {
		this.navigate('new-navigation-tabs')
	},

	navigate: function(urlSuffix) {
		let url = 'forms/' + this.options.formId + '/' + urlSuffix
		conductor.navigate(url, { trigger: true })
	},

	autoRemove: true

})

export default AddTreeMenu

AddTreeMenu.__filename__ = 'forms/add-tree-menu.js'
